/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { Link } from "@fluentui/react";

import { DetailWrapper } from "Containers/Common/CommonContainer.styles";

/**
 * Unauthorized user Container.
 * @returns {React.ReactElement} rendered container
 */
const UnauthorizedContainer = (): React.ReactElement => {
  return (
    <DetailWrapper>
      <div>
        It seems like you are not authorized to view this page. Please contact one of the email
        addresses below to resolve the issue.
      </div>
      <br />
      <ul>
        <li>
          Student Ambassador Program:&nbsp;
          <Link href="mailto:sa-help@microsoft.com">sa-help@microsoft.com</Link>
        </li>
        <li>
          MVP Program:&nbsp;<Link href="mailto:mvpga@microsoft.com">mvpga@microsoft.com</Link>
        </li>
        <li>
          RD Program:&nbsp;
          <Link href="mailto:rd-program@microsoft.com">rd-program@microsoft.com</Link>
        </li>
      </ul>
    </DetailWrapper>
  );
};

export default UnauthorizedContainer;
